/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { Comment, ReactQueryKeys } from '@/types'
import { useContext } from 'react'
import { AxiosContext } from '@/context/Axios'
import useAppStore from '@/store/useAppStore'
import { shallow } from 'zustand/shallow'
import { emitAppEvent } from '@/events/eventBus'
import { AppEvents } from '@/events/eventTypes'
import { getNowInUTC } from '@/utils/helper'
import { useAuth } from '@/hooks/common'

interface Params {
  topicID: string
  noteID: string
  comment: string
  interactionType: '3' | '2' // 3 for liking // 2 Comments
  interaction: '0' | '1' // 1: like, 0: dislike for interactionType = 3 only
}

export const useInteractToNote = (isDM: boolean = false) => {
  const { basicInfo } = useAuth()
  const axios = useContext(AxiosContext)
  const { updateTopicList, setMyDMConnections } = useAppStore()

  const [topicList, myDMConnections] = useAppStore(
    (state) => [state.home.topicList, state.user.myDMConnections],
    shallow,
  )

  const updateLikeStatus = (params: Params) => {
    if (isDM) {
    } else {
      const topic = topicList[params.topicID]
      const isLiked = params.interaction == '1'
      const likesCount = `${Number(topic.totalLikes) + (isLiked ? 1 : -1)}`

      const updatedNotes = topicList[params.topicID]?.notes?.map((i) => {
        if (i.noteID == params.noteID) {
          return {
            ...i,
            isThumbsUp: isLiked ? 1 : 0,
            thumbsUp: `${Number(i.thumbsUp) + (isLiked ? 1 : -1)}`,
          }
        } else {
          return i
        }
      })

      let updatedFirstNote = topic.firstNote

      if (topic.firstNote && topic.firstNote.noteID == params.noteID) {
        updatedFirstNote = {
          ...topic.firstNote,
          isThumbsUp: isLiked ? 1 : 0,
          thumbsUp: String(Number(topic.firstNote.thumbsUp || 0) + (isLiked ? 1 : -1)),
        }
      }

      updateTopicList({
        [params.topicID]: {
          ...topicList[params.topicID],
          notes: updatedNotes,
          firstNote: updatedFirstNote,
          totalLikes: likesCount,
        },
      })

      emitAppEvent(AppEvents.NOTE_LIKE_STATUS_UPDATED, {
        topicID: topic.topicID,
        noteID: params.noteID,
        isLiked,
      })
    }
  }
  const addNoteComment = (params: Params) => {
    if (isDM) {
    } else {
      const topic = topicList[params.topicID]
      const commentsCount = `${Number(topic.totalComments) + 1}`

      const updatedNotes = topicList[params.topicID]?.notes?.map((i) => {
        if (i.noteID == params.noteID) {
          return {
            ...i,
            comments: i.comments + 1,
          }
        } else {
          return i
        }
      })

      updateTopicList({
        [params.topicID]: {
          ...topicList[params.topicID],
          notes: updatedNotes,
          totalComments: commentsCount,
        },
      })
    }
  }

  const onCommentAdded = (responseData: any, params: Params) => {
    // {
    // "requestID": "22145962a001c72c4fd708af917ab780_654746a568541594f55.62754787",
    // "isError": false,
    // "hasData": true,
    // "message": "Interaction Added",
    // "commentID": "8514",
    // "comment": "Test"
    // }

    const newComment: Comment = {
      comment: params.comment,
      dateAdded: getNowInUTC(),
      feedbackID: responseData.commentID || '',
      noteID: params.noteID,
      profilePicURL: basicInfo.profilePicURL,
      senderID: basicInfo.userID,
      senderName: `${basicInfo.firstName} ${basicInfo.lastName}`,
      topicID: params.topicID,
      userID: basicInfo.userID,
    }

    emitAppEvent(AppEvents.NOTE_COMMENT_ADDED, {
      topicID: params.topicID,
      noteID: params.noteID,
      comment: newComment,
    })
  }

  return useMutation({
    mutationKey: [ReactQueryKeys.INTERACT_ALBUM],
    mutationFn: async (params: Params) => {
      if (params.interactionType == '3') {
        updateLikeStatus(params)
      } else if (params.interactionType == '2') {
        addNoteComment(params)
      }

      const response = await axios.api.post('ajax/topics', {
        requestType: 'topicNoteInteract',
        format: 'json',
        ...params,
      })

      if (response.data && !response.data.isError) onCommentAdded(response.data, params)
      return response.data
    },
  })
}
